import { PeriscopeSource } from '@ui/icons';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { Col, Row } from 'antd';
import { DataDictionaryEntry, DataDictionaryField } from '@sonar-software/sonar-core';
import { PopulationPercentageTag, ReferenceCountTag } from '@ui/tags';

export interface PrimaryColumnProps {
	label: string;
	entry: DataDictionaryEntry;
}

export const PrimaryColumn: React.FC<PrimaryColumnProps> = ({ label, entry }) => {
	const { name, sonarObjectId, sourceUrl } = entry;
	const { populationPercentage, referenceCount } = entry as DataDictionaryField;

	return (
		<div>
			<Row
				justify='space-between'
				wrap={ false }>
				<Col className='label'>{ label?.trim() }</Col>
				<Col className='source-link'>
					<PeriscopeSource
						id={ `${sonarObjectId}-link` }
						sonarObjectType={ SonarObjectType.SalesforceField }
						url={ sourceUrl } />
				</Col>
			</Row>
			<Row>
				<ReferenceCountTag count={ referenceCount } />
				<PopulationPercentageTag
					parentName={ name }
					percent={ populationPercentage } />
			</Row>
		</div>
	);
};
